import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VideosState } from '../reducers/videos.reducer';
import { VIDEOS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<VideosState>(VIDEOS_FEATURE_KEY);

export const selectVideo = (id: string) => createSelector(selectState, (state) => state.videos[id]?.video ?? null);
export const selectLoading = (id: string) => createSelector(selectState, (state) => state.videos[id]?.loading ?? null);
